import { render, staticRenderFns } from "./wbAdvSelect.vue?vue&type=template&id=64e44f9a"
import script from "./wbAdvSelect.vue?vue&type=script&lang=js"
export * from "./wbAdvSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports